import React from 'react';
export function Byline() {
  // Calculate yesterday's date
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  // Format the date as "Month Day, Year"
  const formattedDate = yesterday.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return <div className="flex flex-col gap-1 text-sm text-gray-600 border-t border-b border-gray-200 py-3" data-id="element-23">
      <div className="flex items-center gap-2" data-id="element-24">
        <span data-id="element-25">By Margaret Reynolds</span>
        <span className="text-gray-400" data-id="element-26">|</span>
        <span data-id="element-27">Beauty & Wellness</span>
      </div>
      <span className="text-gray-500" data-id="element-28">{formattedDate}</span>
    </div>;
}